import { Outlet } from 'react-router'
import { selectGateView, useDeviceGate } from '../../state/device'
import { useSession } from '../../state/session'
import { DeviceBlockedScreen } from '../device/DeviceBlockedScreen'
import { DevicePendingScreen } from '../device/DevicePendingScreen'
import { SignInScreen } from './SignInScreen'

function BootScreen() {
  return (
    <div className="boot-screen" aria-busy="true">
      <span className="spinner" aria-label="Loading BOSS Chat" />
    </div>
  )
}

export function AuthGate() {
  const authStatus = useSession((s) => s.authStatus)
  const me = useSession((s) => s.me)
  const view = useDeviceGate(selectGateView)
  if (me) {
    // In enforce mode the chat shell (and its cached data) only renders for an approved device.
    switch (view) {
      case 'pending':
        return <DevicePendingScreen />
      case 'blocked':
        return <DeviceBlockedScreen />
      case 'checking':
        return <BootScreen />
      default:
        return <Outlet />
    }
  }
  if (authStatus === 'unauthenticated') return <SignInScreen />
  return <BootScreen />
}
